module.exports = __webpack_public_path__ + "static/media/survival-math.98d59f80.jpg";